import { useState, useMemo, useCallback } from 'react';

export function useRowsExpandedState() {
  const [rowsExpanded, setRowsExpanded] = useState<Record<string, boolean>>({});

  const stableActions = useMemo(
    () => ({
      set: (id: string, expanded: boolean) => {
        setRowsExpanded(prev => ({
          ...prev,
          [id]: expanded,
        }));
      },
      setAll: (newState: Record<string, boolean>) => {
        setRowsExpanded(newState);
      },
      setAllValues: (expanded: boolean) => {
        setRowsExpanded(prev =>
          Object.fromEntries(
            Object.entries(prev).map(([id]) => [id, expanded]),
          ),
        );
      },
    }),
    [setRowsExpanded],
  );

  const utils = {
    get: useCallback((id: string) => rowsExpanded[id], [rowsExpanded]),
    ...stableActions,
  };

  return [rowsExpanded, utils] as const;
}
